"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var factory_1 = require("./factory");
var default_1 = require("./default");
factory_1.registerTheme('default', default_1.default); // 注册默认的主题
tslib_1.__exportStar(require("./factory"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/theme/index.js
// module id = 385
// module chunks = 37